<template>
  <v-content class="pattern-background">
    <v-row class="fill-height mb-4" no-gutters align="center" justify="center">
      <v-col
        xs="12"
        sm="6"
        md="6"
        lg="4"
        xl="4"
        class="mt-2 caixa-login-tamanho"
      >
        <h1 class="font-weight-light text-center" style="line-height: 33px">
          Multisign
        </h1>
        <p
          class="text-center mt-0 pt-0 font-italic font-weight-light descricao-app"
        >
          Padronize a assinatura de todos os usuários em sua organização
        </p>

        <v-card
          class="elevation-6 mb-2"
          :loading="carregandoLoginEmailSenha || carregandoLoginGoogle"
          :disabled="carregandoLoginEmailSenha || carregandoLoginGoogle"
        >
          <v-toolbar color="primary titulo-login" dark>
            <v-toolbar-title class="pb-4">Login</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-form @keydown.native.enter="pressionouEnter = true">
              <v-text-field
                v-model="usuario.email"
                label="E-mail"
                name="email"
                prepend-icon="mdi-account"
                type="text"
              ></v-text-field>
              <v-text-field
                v-model="usuario.senha"
                id="senha"
                label="Senha"
                name="senha"
                prepend-icon="mdi-lock"
                type="password"
              ></v-text-field>
            </v-form>
          </v-card-text>
          <v-card-actions class="pt-0">
            <v-row dense justify="center">
              <v-col cols="12" class="text-center" align-self="center">
                <span class="font-italic font-weight-light"
                  >Selecione o método de login</span
                >
              </v-col>
              <v-col cols="12" class="text-start pl-3">
                <v-row no-gutters>
                  <v-col cols="2" md="1" lg="1" xl="1">
                    <c-login-email-senha
                      :usuario="usuario"
                      :carregandoLoginEmailSenha="carregandoLoginEmailSenha"
                      :carregandoLoginGoogle="carregandoLoginGoogle"
                      @gerenciarCarregamentoLoginEmailSenha="
                        carregandoLoginEmailSenha = $event
                      "
                      @redirecionarUsuario="redirecionarUsuario($event)"
                      :pressionouEnter="pressionouEnter"
                    ></c-login-email-senha>
                  </v-col>
                  <v-col cols="10" md="11" lg="11" xl="11" align-self="center">
                    <span class="iniciar-login">Entrar com e-mail e senha</span>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" class="pl-4 pr-3">
                <v-divider></v-divider>
              </v-col>
              <v-col cols="12" class="text-start pl-3">
                <v-row no-gutters>
                  <v-col cols="2" md="1" lg="1" xl="1">
                    <c-login-google
                      @gerenciarCarregamentoLoginGoogle="
                        carregandoLoginGoogle = $event
                      "
                      @redirecionarUsuario="redirecionarUsuario($event)"
                    >
                    </c-login-google>
                  </v-col>
                  <v-col cols="10" md="11" lg="11" xl="11" align-self="center">
                    <span class="iniciar-login">Entrar com google</span>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-content>
</template>

<script>
import LoginGoogle from "../components/login/LoginGoogle.vue";
import LoginEmailSenha from "../components/login/LoginEmailSenha.vue";

export default {
  data() {
    return {
      usuario: {
        email: "multisign@multisign.com",
        senha: "Multi3dro",
      },
      carregandoLoginEmailSenha: false,
      carregandoLoginGoogle: false,
      autorizacaoLoginGoogle: process.env.VUE_APP_ID_CLIENTE_LOGIN_GOOGLE,
      pressionouEnter: false
    };
  },
  methods: {
    redirecionarUsuario(usuario) {
      let rotaCorreta = this.itensMenu.filter((i) => {
        return i.liberadoPara.indexOf(usuario.papel) > -1;
      });
      this.$router.push(rotaCorreta[0].url);
    },
  },
  computed: {
    itensMenu() {
      return this.$store.state.itensMenu;
    },
  },
  components: {
    "c-login-google": LoginGoogle,
    "c-login-email-senha": LoginEmailSenha,
  },
};
</script>

<style scoped>
.img-fundo-login {
  background-image: url("../assets/back-login.jpg");
  background-size: cover;
}

.pattern-background {
  background-image: url("../assets/email-pattern.png");
  background-repeat: repeat;
}
.descricao-app {
  font-size: 0.8em !important;
}
.titulo-login {
  height: 50px !important;
}

.caixa-login-tamanho {
  max-width: 476px;
}

.iniciar-login { 
  font-size: 14px;
}
</style>